import API from 'services/api';
import { fetchWithRetry } from 'services/fetchWithRetry';

class TraceabilityService {
    private readonly getTraceabilityURL = `/admin/traceability`;

    // ---------------------------------------------------------------

    getTraceability(params: {
        size: number;
        page: number;
        serialNumber: string;
        ndcCode: string;
        fromDuns: string;
        toDuns: string;
        startDate: string;
        endDate: string;
    }) {
        return fetchWithRetry(API.get(this.getTraceabilityURL, { params }));
    }
}

export default new TraceabilityService();
